import { Select, SelectProps } from "antd";
import { SEARCH_PARAMS } from "../../../constants/searchParams";
import { useSearchParamsV6 } from "../../../pages/chats/hooks/useSearchParamsV6";
import Label from "../label";

export interface ISelectParamsProps extends SelectProps {
  paramsKey: keyof typeof SEARCH_PARAMS;
  label?: string;
  required?: boolean;
  isSetDefault?: boolean;
  isNumber?: boolean;
}

const SelectParam = (props: ISelectParamsProps) => {
  const { paramsKey, label, required, isSetDefault = true, isNumber, defaultValue, ...rest } = props;

  const [searchParams, setSearchParams] = useSearchParamsV6();

  const value = searchParams.get(paramsKey) || (isSetDefault && defaultValue ? defaultValue : undefined);

  const handleChange = (value: string) => {
    if (value) {
      searchParams.set(paramsKey, value);
    } else {
      searchParams.delete(paramsKey);
    }
    setSearchParams(searchParams);
  };

  return (
    <div className="flex flex-col gap-1">
      {label && <Label required={required}>{label}</Label>}
      <Select
        {...rest}
        defaultValue={isSetDefault ? ((isNumber && value ? parseInt(value) : value) as string) : undefined}
        onChange={handleChange}
      />
    </div>
  );
};

export default SelectParam;
